// @flow
import * as React from 'react';
import EmailFeedbackModal from 'app/common/react/components/growth/email/EmailFeedbackModal';
import Experience from 'app/common/react/components/experiences/Experience/Experience';
import FixEmailModal from 'app/common/react/components/growth/email/FixEmailModal';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import PasswordUpsellModal from 'app/common/react/components/growth/activation/PasswordUpsell/PasswordUpsellModal';
import toCamelCase from 'app/common/lib/util/toCamelCase';
import { deepMapStringKeys } from 'app/common/lib/util/ObjectUtils';

type ExperienceModalProps = { placementId: number };

function getModalClass(experience_id: number): React.ComponentType<any> {
  switch (experience_id) {
    case PCONST.thrift.Experience.WEB_EMAIL_FEEDBACK_MODAL:
      return EmailFeedbackModal;
    case PCONST.thrift.Experience.UPSELL_SOCIAL_USER_SET_PASSWORD:
      return PasswordUpsellModal;
    default:
      return FixEmailModal;
  }
}

const ExperienceModal = ({ placementId }: ExperienceModalProps) => (
  <Experience
    experienceIds={[
      PCONST.thrift.Experience.WEB_EMAIL_FEEDBACK_MODAL,
      PCONST.thrift.Experience.WEB_FIX_BOUNCED_EMAIL,
      PCONST.thrift.Experience.WEB_FIX_EMAIL_MODAL,
      PCONST.thrift.Experience.UPSELL_SOCIAL_USER_SET_PASSWORD,
    ]}
    placementId={placementId}
  >
    {({ experience_id, complete, dismiss, display_data }) => {
      const AnyModal = getModalClass(experience_id);
      return (
        <LegacyModal noButton onHide={dismiss}>
          <AnyModal
            {...deepMapStringKeys(toCamelCase)(display_data)}
            handleComplete={complete}
            handleDismiss={dismiss}
            experienceId={experience_id}
          />
        </LegacyModal>
      );
    }}
  </Experience>
);

export default ExperienceModal;
